import React, { Component } from 'react';

import IconClosedEye from '../../assets/icons/IconClosedEye';
import IconOpenedEye from '../../assets/icons/IconOpenedEye';
import IconStatusCheck from '../../assets/icons/IconStatusCheck';
import IconStatusWarn from '../../assets/icons/IconStatusWarn';
import API_AUTHENTICATION from '../../api/apiAuthentication';
import { ROUTER_CONSTANT } from '../../constants/routerConstant';
import MasterDataUserAlert from './MasterDataUserAlert';
import { getContent } from '../../util/responseUtil';

class MasterDataUserSecondPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showPassword1: false,
            showPassword2: false,
            isAlreadyTaken: '',
            isUsernameValid: false,
            showWarningAlertUsername: false,
            showWarningAlertPassword: false,
            showWarningConfirmPassword: false,
            showWarningAlertUsername1: false,
            showWarningAlertPassword1: false,
            showWarningConfirmPassword1: false,
        }
    }

    handleCheckUser = () => {
        if (this.props.username === '') return
        if (this.props.username.length < 6 || this.props.username.length > 20) return this.setState({ showWarningAlertUsername1: true })

        const data = {
            username: this.props.username
        }

        API_AUTHENTICATION.postDetailUser(data, this.props.token)
            .then(res => {
                if (getContent(res).client_id === '') {
                    this.setState({
                        isAlreadyTaken: false,
                        isUsernameValid: true
                    })
                } else {
                    this.setState({
                        isAlreadyTaken: true,
                        isUsernameValid: true
                    })
                }
            }).catch(err => {
                if (err.response?.status === 400) {
                    this.setState({
                        isAlreadyTaken: false,
                        isUsernameValid: false
                    })
                }
                if (err.response?.status === 401) {
                    this.props.history.push(ROUTER_CONSTANT.LOGIN);
                    this.props.handleLogout();
                }
            })
    }

    handleChangeUsername = async e => {
        await this.props.handleChange(e)
        this.setState({ showWarningAlertUsername1: false })

        const validateUsername = /^[a-z][a-z0-9_.]+$/
        if (!this.props.username.match(validateUsername)) {
            return this.setState({
                showWarningAlertUsername: true,
                isAlreadyTaken: '',
                isUsernameValid: true
            })
        }
        this.setState({
            showWarningAlertUsername: false,
            isAlreadyTaken: '',
            isUsernameValid: true
        })
    }

    handleChangePassword = async e => {
        await this.props.handleChange(e)
        this.setState({ showWarningAlertPassword1: false })

        const validatePassword = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/
        if (!this.props.password.match(validatePassword)) {
            return this.setState({ showWarningAlertPassword: true })
        }
        this.setState({ showWarningAlertPassword: false })
    }

    handleChangeConfirmPassword = async e => {
        await this.props.handleChange(e)
        this.setState({ showWarningConfirmPassword1: false })

        if (this.props.password !== this.props.confirmPassword) {
            return this.setState({ showWarningConfirmPassword: true })
        }
        this.setState({ showWarningConfirmPassword: false })
    }

    handleChangePage = async page => {
        await this.setState({
            showWarningAlertUsername1: false,
            showWarningAlertPassword1: false,
            showWarningConfirmPassword1: false,
        })

        if (this.props.action === 'detail') {
            return this.props.handleChangePage(page)
        }

        if (this.props.username === '') {
            return this.setState({ showWarningAlertUsername1: true, showWarningAlertUsername: false })
        }

        if (this.props.action === 'add' && this.props.clientId === '') {
            if (this.props.password === '') {
                return this.setState({ showWarningAlertPassword1: true, showWarningAlertPassword: false })
            }

            if (this.props.confirmPassword === '') {
                return this.setState({ showWarningConfirmPassword: true, showWarningConfirmPassword1: false })
            }
        }

        this.props.handleChangePage(page)
    }

    render() {
        return (
            <div className="w-full bg-white rounded-b-2xl px-5 py-10 relative calculate-layout-user">
                <div className="flex pb-10 border-b-2 border-gray mb-10" style={{ height: "90%" }}>
                    <div className="w-1/2">
                        <div className="box-1 p-5">
                            <div className="flex">
                                <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                    <p className="mr-1">Nama Pengguna </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}
                                </div>
                                <div className="w-5/6">
                                    <div className="flex items-center w-full">
                                        <input
                                            type="text"
                                            id="tslusername"
                                            className="form-control"
                                            placeholder="Tulis Nama Pengguna"
                                            name="username"
                                            value={this.props.username}
                                            onChange={this.handleChangeUsername}
                                            autoComplete="off"
                                            disabled={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== ''}
                                        />
                                        <button
                                            type="button"
                                            id="btncheckusername"
                                            onClick={() => this.handleCheckUser()}
                                            className={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== '' ? "hidden" : "bg-darkblue rounded text-white font-medium border border-darkblue focus:outline-none px-10 py-2 ml-2"}
                                        >
                                            Periksa
                                        </button>
                                    </div>
                                    {this.state.showWarningAlertUsername && this.props.action !== 'detail' && <MasterDataUserAlert text="Nama Pengguna wajib diisi dengan huruf kecil, angka atau simbol . _" />}
                                    {this.state.showWarningAlertUsername1 && this.props.action !== 'detail' && <MasterDataUserAlert text="Nama Pengguna wajib diisi dengan minimal 6 karakter dan maksimum 20 karakter!" />}
                                </div>
                            </div>

                            <div className={!this.state.isAlreadyTaken && this.state.isAlreadyTaken !== '' ? "flex items-center mt-1 ml-1" : "hidden"}>
                                <div className="w-1/6"></div>
                                <p className="w-5/6 text-xs font-medium flex items-center">
                                    <IconStatusCheck />
                                    <span className="ml-2">Username dapat dipakai</span>
                                </p>
                            </div>

                            <div className={this.state.isAlreadyTaken ? "flex items-center mt-1 ml-1" : "hidden"}>
                                <div className="w-1/6"></div>
                                <p className="w-5/6 text-xs font-medium flex items-center">
                                    <IconStatusWarn />
                                    <span className="ml-2">Username sudah dipakai, silahkan memakai username lain</span>
                                </p>
                            </div>

                            <div className="flex mt-4">
                                <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                    <p className="mr-1">Kata Sandi </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}</div>
                                <div className="w-5/6">
                                    <div className={this.props.action === "detail" ? "disabled-form-control flex items-center justify-between" : "form-control flex items-center justify-between"}>
                                        <input
                                            id="tslpassword"
                                            type={this.state.showPassword1 ? "text" : "password"}
                                            placeholder="Tulis Kata Sandi"
                                            className="custom-input w-11/12"
                                            name="password"
                                            value={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== '' ? "iniadalahpassword" : this.props.password}
                                            onChange={this.handleChangePassword}
                                            autoComplete="new-password"
                                            disabled={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== ''}
                                        />
                                        <div className={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== '' ? "hidden" : "w-1/12"}>
                                            {
                                                this.state.showPassword1
                                                    ? <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: false })} className="cursor-pointer">
                                                        <IconOpenedEye />
                                                    </div>
                                                    : <div id="btnshowpassword1" onClick={() => this.setState({ showPassword1: true })} className="cursor-pointer">
                                                        <IconClosedEye />
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                    {this.state.showWarningAlertPassword && this.props.action !== 'detail' && <MasterDataUserAlert text="Kata Sandi tidak boleh kurang dari 8 karakter & tidak boleh lebih dari 20 karakter & harus memiliki huruf kecil, huruf besar, angka, dan karakter spesial!" />}
                                    {this.state.showWarningAlertPassword1 && this.props.action !== 'detail' && <MasterDataUserAlert text="Kata Sandi tidak boleh kosong!" />}
                                </div>
                            </div>

                            <div className="flex mt-4">
                                <div className="w-1/6 text-right font-bold mr-5 flex justify-end">
                                    <p className="mr-1">Konfirmasi Kata Sandi </p>
                                    {this.props.action !== 'detail' && <span className="text-darkred">*</span>}</div>
                                <div className="w-5/6">
                                    <div className={this.props.action === "detail" ? "disabled-form-control flex items-center justify-between" : "form-control flex items-center justify-between"}>
                                        <input
                                            id="tslconfirmpassword"
                                            type={this.state.showPassword2 ? "text" : "password"}
                                            placeholder="Tulis Konfirmasi Kata Sandi"
                                            className="custom-input w-11/12"
                                            name="confirmPassword"
                                            value={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== '' ? "iniadalahpassword" : this.props.confirmPassword}
                                            onChange={this.handleChangeConfirmPassword}
                                            autoComplete="new-password"
                                            disabled={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== ''}
                                        />
                                        <div className={this.props.action === "detail" || this.props.action === "edit" || this.props?.clientId !== '' ? "hidden" : "w-1/12"}>
                                            {
                                                this.state.showPassword2
                                                    ? <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: false })} className="cursor-pointer">
                                                        <IconOpenedEye />
                                                    </div>
                                                    : <div id="btnshowpassword2" onClick={() => this.setState({ showPassword2: true })} className="cursor-pointer">
                                                        <IconClosedEye />
                                                    </div>
                                            }
                                        </div>
                                    </div>
                                    {this.state.showWarningConfirmPassword && this.props.action !== 'detail' && <MasterDataUserAlert text="Konfirmasi Kata Sandi harus sama dengan Kata Sandi!" />}
                                    {this.state.showWarningConfirmPassword1 && this.props.action !== 'detail' && <MasterDataUserAlert text="Konfirmasi Kata Sandi tidak boleh kosong!" />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="absolute bottom-5 right-5">
                    <button type="button" id="btnback" className="bg-white rounded text-darkblue border border-darkblue focus:outline-none w-32 py-2 mt-3 mr-2" onClick={() => this.props.handleChangePage(1)}>Sebelumnya</button>
                    <button type="submit" id="btnnext" className="bg-lightblue rounded text-white border border-lightblue focus:outline-none w-32 py-2 mt-3 ml-2" onClick={() => this.handleChangePage(3)}>
                        Selanjutnya
                    </button>
                </div>
            </div>
        );
    }
}

export default MasterDataUserSecondPage;